import script from "./step-apply-collection.vue?vue&type=script&setup=true&lang=ts"
export * from "./step-apply-collection.vue?vue&type=script&setup=true&lang=ts"

import "./step-apply-collection.vue?vue&type=style&index=0&id=256acd7e&scoped=true&lang=scss"

import exportComponent from "/Users/macmini/builds/VJ28wZh6J/1/terracycle/tc-mini-site-frontend/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.69.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-256acd7e"]])

export default __exports__